
<button mat-icon-button
  (click)="handleClick()"
  [tmTooltip]="tooltip || ''"
  matTooltipPosition="right"
  [matMenuTriggerFor]="menuTrigger"
  [matBadge]="menuTrigger ? null : badgeCount"
  matBadgeSize="small"
  matBadgeColor="primary"
  [class.button--active]="(active$ | async) ?? false"
  [aria-expanded]="menuTrigger ? null : (active$ | async)">
  @if (icon) {
    <mat-icon [svgIcon]="icon"></mat-icon>
  }
  <ng-content></ng-content>
</button>
